import { NgModule } from '@angular/core';
import { MatCommonModule } from '@angular/material';

import { DefaultImageDirective } from './directives';
import { LineTruncatorPipe, SeparatorReplacerPipe, IntegerPipe, CpfcPipe } from './pipes';

export * from './abstract';
export * from './converters';
export * from './dictionaries';
export * from './models';
export * from './services';
export * from './helpers';

@NgModule({
  imports: [
    MatCommonModule
  ],
  declarations: [DefaultImageDirective, LineTruncatorPipe, SeparatorReplacerPipe, IntegerPipe, CpfcPipe],
  exports: [DefaultImageDirective, LineTruncatorPipe, SeparatorReplacerPipe, IntegerPipe, CpfcPipe]
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts